import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { Typography, Box, Chip } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { formatBytes } from "../../utils/fileUpload";
import { titanAviationIntance } from "..";

const DEFAULT_MAX_FILE_SIZE = 2.5 * 1024 * 1024 * 1024
const SUPPORTED_EXTENSIONS = [ ".pdf", ".doc", ".docx", ".xls", ".xlsx",".txt", ".jpg", ".jpeg", ".png"];

const AttachmentsUpload = ({ acceptedFile, onFileChange, isDisabled, docError,attachments=[],remainingStorage=0,isNote='',maxFileSize=DEFAULT_MAX_FILE_SIZE,maxFiles }) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [totalSize,setTotalSize]=useState(0);
  const maxFilesReached = !!maxFiles && files.length >= maxFiles;

    const onDrop = (acceptedFiles, rejectedFiles) => {
      setError(null);
     const newFiles = [];
     let file_size=0;
      if (maxFiles && files.length + acceptedFiles.length > maxFiles) {
        setError(`You can upload a maximum of ${maxFiles} files.`);
        return;
      }
      for (let file of acceptedFiles) {
      const ext = "." + file.name.split(".").pop().toLowerCase();

      if (!SUPPORTED_EXTENSIONS.includes(ext)) {
        setError(`File type ${ext} not supported.`);
        continue;
      }
       if (file.size > maxFileSize) {
      setError(
        `File ${file.name} is too big. Max allowed is ${formatBytes(maxFileSize)}`
      );
      continue;
        }
       if(files?.find(oldFile=> oldFile?.name===file?.name) || attachments?.find(oldAttachment=> oldAttachment?.file_name===file?.name )){
          enqueueSnackbar(`${file?.name} is already exists`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
        continue;
      }
      newFiles.push(file);
      file_size+=file?.size;
      }
      if(totalSize+file_size>remainingStorage){
           enqueueSnackbar(`Not enough space. Available Space: ${formatBytes(remainingStorage)}`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
           return;
      }
      setTotalSize((p)=>p+file_size)
     const updatedFiles = [...files, ...newFiles];
     setFiles(updatedFiles);

     if (onFileChange) {
      onFileChange(updatedFiles);
     }

     if (rejectedFiles.length) {
      setError("Some files were rejected. Please check type/size.");
     }
    };

     const removeFile = (file) => {
     const updatedFiles = files.filter((f) => f.name !== file?.name);
      setTotalSize((p)=>p-file?.size)
     setFiles(updatedFiles);
     if (onFileChange) {
      onFileChange(updatedFiles);
     }
    };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    disabled: isDisabled || maxFilesReached,
    accept: {
      "application/pdf": [".pdf"],

      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],

      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],

      "text/plain": [".txt"],

      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
    },
  });
  return (
    <Box>
      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed #ccc",
          borderRadius: "8px",
          p: 3,
          textAlign: "center",
          cursor: (isDisabled || maxFilesReached) ? "not-allowed" : "pointer",
          backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
        }}
      >
        <input {...getInputProps()} />
        <Typography style={{ fontSize: "13px" }}>
          {isDisabled
            ? "Maximum File has been uploaded"
            : maxFilesReached
            ? `Maximum ${maxFiles} files allowed`
            : "Drag and drop, or click here to upload file(s)"}
        </Typography>
      </Box>
      {error && (
        <Typography color="error" style={{ fontSize: "12px", marginTop: "5px" }}>
          {error}
        </Typography>
      )}
      {files.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2">Preview:</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {files.map((file,index) => (
              <Chip
                key={index}
                label={file.name}
                onDelete={() => removeFile(file)}
                variant="outlined"
              />
            ))}
          </Box>
        </Box>
      )}
      {docError ? <Typography sx={{ color: '#d32f2f', fontSize: 12,  }}>
        {docError}
      </Typography> : null}
      <Typography
        style={{ fontSize: "12px", display: "inline-block",background: titanAviationIntance && isNote ? "transparent" : "#ffff96",marginTop:'8px' }}
      >
       {/* Note : Supported extension (.pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png), max upto 2.5 GB. */}
       Note : Supported extension ({SUPPORTED_EXTENSIONS.join(", ")}), max upto {formatBytes(remainingStorage)}.
       {maxFileSize !== DEFAULT_MAX_FILE_SIZE ? ` Maximum File Size : ${formatBytes(maxFileSize)}.` : ''}
       {maxFiles ? ` Maximum ${maxFiles} files allowed.` : ''}
      </Typography>
      {titanAviationIntance && isNote && (
        <div style={{ background: "yellow",fontSize:'13px',marginTop:'5px'}}>
          The file name must include a keyword{" "}
          <span style={{ fontWeight: 900,fontSize:'15px' }}>
            {isNote}
          </span>{" "}
          and it should be an image file for it to appear in the Lease Summary Report.
        </div>
        
      )} 
   </Box>
  );
};

export default AttachmentsUpload;
